import { Rating, styled } from '@mui/material'

export const StyledRating = styled(Rating)({
  '& .MuiRating-icon': {
    color: '#A30A32',
  },
})
